'use client';

import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { type RefObject, useLayoutEffect, useRef } from 'react';
import { replaceTemplateVariables } from '@module/mdrt-org/dashboard/dashboard-page-content/components/pdf-modal-wrapper/press-release-pdf-modal/utils/replace-template-variables/replace-template-variables';
import { localesUsingSpecialSymbols } from '@module/mdrt-org/dashboard/dashboard-page-content/components/pdf-modal-wrapper/use-pdf-font-loader';
import { type Locale } from '@module/mdrt-org/shared/utils/enums/locale';
import styles from './pdf-preview.module.scss';
const STATIC_FIELDS = ['AboutMDRTSectionPlaceholder', 'BusinessContactInformationPlaceholder', 'ContactInformationLabelPlaceholder', 'ContentArea1Placeholder', 'ContentArea2Placeholder', 'ContentSectionPlaceholder', 'COTMembershipYears', 'HeaderPlaceholder', 'MdrtAchievements', 'MembershipYears', 'SubheaderPlaceholder', 'TOTMembershipYears', 'DonorLevel'];
const IMG_SRC_FIELDS = new Set(['ProfilePictureUrlPlaceholder']);
const HTML_FIELDS = new Set(['Email', 'PhoneNumber']);
export const PdfPreview = t0 => {
  const $ = _c(16);
  const {
    activeField,
    className,
    htmlTemplate,
    isPrintable,
    locale,
    pdfDocumentData,
    ref
  } = t0;
  const contentRef = useRef(null);
  const lastTemplateRef = useRef("");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const lastDataRef = useRef(t1);
  let t2;
  let t3;
  if ($[1] !== activeField || $[2] !== htmlTemplate || $[3] !== isPrintable || $[4] !== locale || $[5] !== pdfDocumentData) {
    t2 = () => {
      if (!contentRef.current) {
        return;
      }
      const needsFullRender = lastTemplateRef.current !== htmlTemplate || !contentRef.current.hasChildNodes() || [...IMG_SRC_FIELDS].some(field => lastDataRef.current[field] !== pdfDocumentData[field]);
      if (needsFullRender) {
        contentRef.current.innerHTML = replaceTemplateVariables(htmlTemplate, pdfDocumentData, activeField, STATIC_FIELDS, isPrintable, locale);
        lastTemplateRef.current = htmlTemplate;
        lastDataRef.current = {
          ...pdfDocumentData
        };
      } else {
        const variableElements = contentRef.current.querySelectorAll("[data-var]");
        variableElements.forEach(element => {
          const key = element.dataset.var;
          if (!key || !(key in pdfDocumentData)) {
            return;
          }
          const newValue = String(pdfDocumentData[key] ?? "");
          const hasTemplateTokens = /\{\{\s*\w+\s*\}\}/u.test(newValue);
          if (hasTemplateTokens) {
            const rendered = replaceTemplateVariables(newValue, pdfDocumentData, activeField, STATIC_FIELDS, isPrintable, locale);
            if (element.innerHTML !== rendered) {
              element.innerHTML = rendered;
            }
          } else {
            if (HTML_FIELDS.has(key)) {
              if (lastDataRef.current[key] !== pdfDocumentData[key]) {
                element.innerHTML = newValue;
              }
            } else {
              if (element.textContent !== newValue) {
                element.textContent = newValue;
              }
            }
          }
          const newClassName = ["pdf-preview", isPrintable ? "pdf-preview--printable" : "", activeField === key ? "pdf-preview--active" : ""].filter(Boolean).join(" ");
          if (element.className !== newClassName) {
            element.className = newClassName;
          }
        });
        lastDataRef.current = {
          ...pdfDocumentData
        };
      }
      for (const anchor of Array.from(contentRef.current.querySelectorAll("a"))) {
        anchor.target = "_blank";
        anchor.rel = "noreferrer";
      }
    };
    t3 = [activeField, htmlTemplate, isPrintable, locale, pdfDocumentData];
    $[1] = activeField;
    $[2] = htmlTemplate;
    $[3] = isPrintable;
    $[4] = locale;
    $[5] = pdfDocumentData;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  useLayoutEffect(t2, t3);
  let t4;
  if ($[8] !== className || $[9] !== isPrintable || $[10] !== locale) {
    t4 = classNames(styles["pdf-document-content"], className, {
      [styles["pdf-document-content--locale-adjusted-font"]]: localesUsingSpecialSymbols.includes(locale as Locale),
      [styles["pdf-document-content--printable"]]: isPrintable
    });
    $[8] = className;
    $[9] = isPrintable;
    $[10] = locale;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span ref={contentRef} />;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== ref || $[14] !== t4) {
    t6 = <div className={t4} ref={ref}>{t5}</div>;
    $[13] = ref;
    $[14] = t4;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};